import {
  REQUEST_LOGISTIC_GROUPS,
  RESPONSE_LOGISTIC_GROUPS,
  REQUEST_LOGISTIC_GROUPS_FAILURE,
  REQUEST_CREATE_LOGISTIC_GROUPS,
  RESPONSE_CREATE_LOGISTIC_GROUPS,
  REQUEST_CREATE_LOGISTIC_GROUPS_FAILURE,
  REQUEST_DELETE_LOGISTIC_GROUPS,
  RESPONSE_DELETE_LOGISTIC_GROUPS,
  REQUEST_DELETE_LOGISTIC_GROUPS_FAILURE,
  REQUEST_CREATE_CP_LOGISTIC_GROUPS,
  RESPONSE_CREATE_CP_LOGISTIC_GROUPS,
  REQUEST_CREATE_CP_LOGISTIC_GROUPS_FAILURE,
  REQUEST_DELETE_CP_LOGISTIC_GROUPS,
  RESPONSE_DELETE_CP_LOGISTIC_GROUPS,
  REQUEST_DELETE_CP_LOGISTIC_GROUPS_FAILURE,
  SELECT_LOGISTIC_GROUPS,
} from "../actions/logisticGroupsActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  logisticGroupsDataState: queriesStates.NOT_REQUESTED,
  logisticCreateGroupDataState: queriesStates.NOT_REQUESTED,
  logisticDeleteGroupDataState: queriesStates.NOT_REQUESTED,
  logisticCreateControlPointGroupDataState: queriesStates.NOT_REQUESTED,
  logisticDeleteControlPointGroupDataState: queriesStates.NOT_REQUESTED,
  logisticGroups: [],
  logisticSelectedGroup: null,
  errors: [],
};

const logisticGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_LOGISTIC_GROUPS: {
      return Object.assign({}, state, {
        logisticGroupsDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_LOGISTIC_GROUPS: {
      return Object.assign({}, state, {
        logisticGroupsDataState: queriesStates.READY,
        logisticGroups: action.data.logisticGroups,
      });
    }
    case REQUEST_LOGISTIC_GROUPS_FAILURE: {
      return Object.assign({}, state, {
        logisticGroupsDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_CREATE_LOGISTIC_GROUPS: {
      return Object.assign({}, state, {
        logisticCreateGroupDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CREATE_LOGISTIC_GROUPS: {
      return Object.assign({}, state, {
        logisticCreateGroupDataState: queriesStates.READY,
        logisticGroups: [action.data].concat(state.logisticGroups),
        logisticSelectedGroup: action.data,
      });
    }
    case REQUEST_CREATE_LOGISTIC_GROUPS_FAILURE: {
      return Object.assign({}, state, {
        logisticCreateGroupDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_LOGISTIC_GROUPS: {
      return Object.assign({}, state, {
        logisticDeleteGroupDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_LOGISTIC_GROUPS: {
      return Object.assign({}, state, {
        logisticDeleteGroupDataState: queriesStates.READY,
        logisticSelectedGroup: null,
        logisticGroups: state.logisticGroups.filter((x) => {
          return x.id !== action.data.id;
        }),
      });
    }
    case REQUEST_DELETE_LOGISTIC_GROUPS_FAILURE: {
      return Object.assign({}, state, {
        logisticDeleteGroupDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_CREATE_CP_LOGISTIC_GROUPS: {
      return Object.assign({}, state, {
        logisticCreateControlPointGroupDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_CREATE_CP_LOGISTIC_GROUPS: {
      const logisticSelectedGroup = state.logisticSelectedGroup;
      logisticSelectedGroup.controlPoints.push(action.controlPoint);

      return Object.assign({}, state, {
        logisticCreateControlPointGroupDataState: queriesStates.READY,
        logisticGroups: state.logisticGroups.map((x) => {
          if (x.id === logisticSelectedGroup.id) {
            return logisticSelectedGroup;
          }
          return x;
        }),
        logisticSelectedGroup: logisticSelectedGroup,
      });
    }
    
    case REQUEST_CREATE_CP_LOGISTIC_GROUPS_FAILURE: {
      return Object.assign({}, state, {
        logisticCreateControlPointGroupDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case REQUEST_DELETE_CP_LOGISTIC_GROUPS: {
      return Object.assign({}, state, {
        logisticDeleteControlPointGroupDataState: queriesStates.REQUEST,
        errors: [],
      });
    }
    case RESPONSE_DELETE_CP_LOGISTIC_GROUPS: {
      const _logisticSelectedGroup = state.logisticSelectedGroup;
      _logisticSelectedGroup.controlPoints = _logisticSelectedGroup.controlPoints.filter((x) => {
        return x.id !== action.controlPoint.id;
      });

      return Object.assign({}, state, {
        logisticDeleteControlPointGroupDataState: queriesStates.READY,
        logisticGroups: state.logisticGroups.map((x) => {
          if (x.id === _logisticSelectedGroup.id) {
            return _logisticSelectedGroup;
          }
          return x;
        }),
        logisticSelectedGroup: _logisticSelectedGroup,
      });
    }
    case REQUEST_DELETE_CP_LOGISTIC_GROUPS_FAILURE: {
      return Object.assign({}, state, {
        logisticDeleteControlPointGroupDataState: queriesStates.FAILURE,
        errors: action.errors,
      });
    }

    case SELECT_LOGISTIC_GROUPS: {
      return Object.assign({}, state, {
        logisticSelectedGroup: action.data,
      });
    }

    default:
      return state;
  }
};

export default logisticGroupsReducer;
